import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {PipesModule} from '../../../shared/pipes/pipes.module';

import {UserListRepository} from './repositories/user-list.repository';
import {UserListService} from './services/user-list.service';
import {UserListRoutingModule} from './user-list-routing.module';
import {UserListComponent} from './user-list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    UserListRoutingModule,
    ModalConfirmationModule,
    SearchBarModule,
    PipesModule,
  ],
  declarations: [
    UserListComponent,
  ],
  providers: [
    UserListService,
    UserListRepository,
  ],
})
export class UserListModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-list/user-list.module.ts